export default __webpack_public_path__ + "static/media/Auto-Suggestions.be7a32ef.png";